import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotfoundComponent } from './notfound/notfound.component';
import { AuthGuard } from './guard/auth.guard';

console.log(window.location.hash.split('/')[1]);
if(window.location.hash.split('/')[1]=='creationsinfra'){
  localStorage.setItem("waldo_sub_domain","creationsinfra");
}else if(window.location.hash.split('/')[1]=='waldoerp'){
  localStorage.setItem("waldo_sub_domain","waldoerp");
}
const routes: Routes = [
  
  { path: '', redirectTo: 'waldoerp/login', pathMatch: 'full' },
  { path: localStorage.getItem("waldo_sub_domain") || 'waldoerp', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),canActivate: [AuthGuard] },  
  { path: 'creationsinfra', redirectTo: 'creationsinfra/login', pathMatch: 'full' },
  { path: 'test', redirectTo:  'test/login', pathMatch: 'full' },
  { path: 'waldoerp', redirectTo:  'waldoerp/login', pathMatch: 'full' },
  { path:  'creationsinfra/login', loadChildren: () => import('./indexlogin/indexlogin.module').then(m => m.IndexloginModule) },
  { path:  'test/login', loadChildren: () => import('./indexlogin/indexlogin.module').then(m => m.IndexloginModule) },
  { path:  'waldoerp/login', loadChildren: () => import('./indexlogin/indexlogin.module').then(m => m.IndexloginModule) },
  { path: '**', redirectTo: '/notfound'},
  { path: 'notfound', component: NotfoundComponent }
]


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled', useHash: true,
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }